import React from "react";
import "./Csoon.scss";
import Comingsoon from "../../media/New_Desktop.webp";
import Soon from "../../media/New_Mobile.webp";

const handleConsultationClick = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6281770998006&text=Halo%20Andi,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Rumah%20(Pre-launch)%20https://eonna-bsdcity.com/%20()&type=phone_number&app_absent=0";
  window.open(whatsappLink, "_blank");
};

const soon = () => {
  return (
    <div id="newlaunching" className="container-soon">
      <div className="bellefont">
        <h1>Pre-launching BSD City</h1>
        <h2>Harga Start from 1,5M</h2>
      </div>
      <div className="maps-lokasi">
        <img className="img-Desktop" src={Comingsoon} alt="maps" />
        <img className="img-lokasi-mobile" src={Soon} alt="maps" />
      </div>
      <div className="button">
        <div className="container-wa">
          <button className="buttonpenawaran" onClick={handleConsultationClick}>
            More Info
          </button>
        </div>
      </div>
    </div>
  );
};

export default soon;
